/* eslint-disable vue/valid-v-slot */
<template>
  <div class="container pa-4">
    <div class="d-flex justify-space-between align-center mb-6">
      <span class="text-h5">Topic Selection</span>
    </div>

    <v-card class="topic-selection-card">
      <v-data-table
        v-model="selected"
        :sort-by="sortBy"
        show-select 
        :headers="tableHeaders" 
        :items="segmentData" 
        class="topic-table"
        density="comfortable"
        item-value="id"
        return-object
      >
        <!-- eslint-disable vue/valid-v-slot -->
        <template #header.data-table-select>Selected</template>
        <!-- eslint-enable vue/valid-v-slot -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { getDatabase, ref, set } from "firebase/database";

export default {
  name: 'WorkshopTopicSelection',
  props: {
    workshopId: String,
    customerId: String,
    workshopData: Object
  },
  components: {},
  data() {
    return {
      selected: [],
      localWorkshopData: null,
      segmentData: [],
      tableHeaders: [
        {
          title: 'Name',
          align: 'start',
          key: 'text.en.name'
        },
        {
          title: 'Category',
          align: 'start',
          key: 'category'
        },
        {
          title: 'Potential',
          align: 'end',
          key: 'potential'
        },
        {
          title: 'Where we want to be',
          align: 'end',
          key: 'voteWhereWantToBe'
        },
        {
          title: 'Where we are',
          align: 'end',
          key: 'voteWhereWeAre'
        },
      ],
      sortBy: [{ key: 'potential', order:'desc'}]
    };
  },
  computed: {
  },
  created() {
    this.initializeLocalData();
    this.loadTextWithVoteAndPotential();
  },
  watch: {
    selected(newVal) {
      if (newVal && newVal.length > 0) {
        console.log('Selected topics changed:', newVal);
        this.saveTopics(newVal.map(item => item.id));
      }
    },
    workshopData: {
      handler(newVal) {
        if (newVal) {
          console.log('Workshop data changed:', newVal);
          this.initializeLocalData();
          this.loadTextWithVoteAndPotential();
        }
      },
      deep: true
    }
  },
  methods: {
    initializeLocalData() {
      this.localWorkshopData = JSON.parse(JSON.stringify(this.workshopData || {}));
    },
    loadTextWithVoteAndPotential() {
      const data = [];
      const segmentDataImport = require('../data/segment.json');
      console.log('Loading text with vote and potential, workshop data:', this.localWorkshopData);

      for (const cat of segmentDataImport) {
        for (const subcat of cat.children) {
          // Check if we have results for this topic
          const result = (this.localWorkshopData.results || {})[subcat.id];
          if (result) {
            data.push({ 
              id: subcat.id,
              category: cat.text.en.name,
              voteWhereWantToBe: result.voteWhereWantToBe,
              voteWhereWeAre: result.voteWhereWeAre, 
              potential: result.voteWhereWantToBe - result.voteWhereWeAre,
              ...subcat
            });
          }
        }
      }

      // Sort data by potential and vote
      data.sort((x, y) => {
        if (x.potential !== y.potential) {
          return y.potential - x.potential;
        }
        return x.voteWhereWantToBe - y.voteWhereWantToBe;
      });

      this.segmentData = data;
      console.log('Processed segment data:', this.segmentData);

      // Initialize selected topics from workshop data
      const selectedTopics = this.localWorkshopData.selectedTopics || [];
      console.log('Current workshop selected topics:', selectedTopics);

      // Always try to find and set selected items from segmentData
      const selectedItems = this.segmentData.filter(item => selectedTopics.includes(item.id));
      console.log('Found selected items:', selectedItems);
      this.selected = selectedItems;
      
      // If no selection and we have data, select top 3
      if (this.selected.length === 0 && this.segmentData.length > 0) {
        this.selected = this.segmentData.slice(0, 3);
        // Save the initial selection
        this.saveTopics(this.selected.map(item => item.id));
      }
    },
    async saveTopics(selectedIds) {
      try {
        console.log('Saving selected topics:', selectedIds);
        const db = getDatabase();
        const selectedTopicsRef = ref(db, `customers/${this.customerId}/workshop/${this.workshopId}/selectedTopics`);
        await set(selectedTopicsRef, selectedIds);
        
        // Update local data
        this.localWorkshopData.selectedTopics = selectedIds;
        
        // Emit selection update
        this.$emit('selection-updated', selectedIds);
      } catch (error) {
        console.error('Error saving selected topics:', error);
      }
    },
    next() {
      const selectedIds = this.selected.map(item => item.id);
      console.log('Next clicked with selected IDs:', selectedIds);
      this.saveTopics(selectedIds);
      this.$emit('next');
    },
    back() {
      const selectedIds = this.selected.map(item => item.id);
      console.log('Back clicked with selected IDs:', selectedIds);
      this.saveTopics(selectedIds);
      this.$emit('back');
    }
  }
};
</script>

<style>
.container {
  max-width: 1400px;
  margin: 0 auto;
}

.topic-selection-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.topic-table {
  width: 100%;
}

.text-h5 {
  font-size: 1.25rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.0125em !important;
}

:deep(.v-data-table) {
  background: transparent !important;
}

:deep(.v-data-table__tr) {
  border-bottom: thin solid rgba(var(--v-border-color), 0.12) !important;
}

:deep(.v-data-table__tr:last-child) {
  border-bottom: none !important;
}

:deep(.v-data-table__th) {
  font-weight: 500 !important;
  color: rgba(var(--v-theme-on-surface), 0.87) !important;
  background: var(--v-theme-background) !important;
}

:deep(.v-data-table-header) {
  border-bottom: thin solid rgba(var(--v-border-color), 0.12) !important;
}

.gap-2 {
  gap: 8px;
}
</style>
